// src/data/api/helios-service/categoryService.ts

import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import { Category } from 'src/types/helios/Category';
import {
  ListCategoriesRequest,
  ListCategoriesResponse,
  GetCategoriesRequest,
  GetCategoriesResponse,
  CreateCategoriesRequest,
  CreateCategoriesResponse,
  UpdateCategoriesRequest,
  UpdateCategoriesResponse,
} from 'src/types/helios/Category';

export const categoryService = {
  getAll: (data: ListCategoriesRequest) => {
    return apiClient.get<ListCategoriesResponse>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.CATEGORIES.LIST(data.businessUnitId)),
      data,
    );
  },
  create: (data: CreateCategoriesRequest) => {
    return apiClient.post<CreateCategoriesResponse, CreateCategoriesRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.CATEGORIES.CREATE(
          data.businessUnitId,
          data.divisionName,
        ),
      ),
      data,
    );
  },
  get: (data: GetCategoriesRequest) => {
    return apiClient.get<GetCategoriesResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.CATEGORIES.GET(
          data.businessUnitId,
          data.divisionName,
          data.categoryName,
        ),
      ),
      data,
    );
  },
  update: (data: UpdateCategoriesRequest) => {
    return apiClient.put<UpdateCategoriesResponse, UpdateCategoriesRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.CATEGORIES.UPDATE(
          data.businessUnitId,
          data.divisionName,
          data.categoryName,
        ),
      ),
      data,
    );
  },
};
